export const FillType = {
  Solid: 'solid',
  Hollow: 'hollow'
}